// Import app styles
import "./styles/main.scss";

// Add assets to /dist
import "./assets/favicon.ico";
import "./assets/watermark.png";

// Polyfills
import "es6-object-assign/auto"; // IE - Used by vue-js-modals
import "es6-promise/auto"; // IE - Promise
